import { c as _c } from "react/compiler-runtime";
import classnames from 'classnames';
const className = classnames('text-3xl', 'text-card-text-color', 'text-center');
interface Props {
  children: string;
}
const ErrorTitle = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <h3 className={className}>{children}</h3>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default ErrorTitle;